// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"4a9cb3bf","419":"a85c2617","439":"70bc24d9","474":"51500cb0","631":"25965344","774":"675c6cf5","787":"0d4b17dd","858":"7e8f5df8"}[chunkId] + ".chunk.js";
};